import { GOOGLE_ADS_ID } from './googleAdsTracking'

const MARKETING_PATH_PREFIXES = [
  '/',
  '/plans-and-pricing',
  '/dna-kit',
  '/dna-kit-success',
  '/dna-kit-guest-success',
  '/terms',
  '/privacy',
  '/partner-terms',
  '/client-waiver',
  '/goals-partners',
  '/press',
  '/account/delete',
  '/docs/ai',
  '/developers',
  '/claude',
  '/how-to-use',
  '/partners/',
  '/practitioner-spotlight',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
]

/** Public marketing/auth pages only — never load ad tags inside the authenticated app. */
export function isMarketingRoute(pathname: string): boolean {
  if (pathname.startsWith('/account') && pathname !== '/account/delete') return false
  if (
    pathname.startsWith('/dashboard') ||
    pathname.startsWith('/genechat') ||
    pathname.startsWith('/wellness') ||
    pathname.startsWith('/health-records') ||
    pathname.startsWith('/billing') ||
    pathname.startsWith('/pro-dashboard') ||
    pathname.startsWith('/ap/')
  ) {
    return false
  }
  return MARKETING_PATH_PREFIXES.some((prefix) =>
    prefix === '/' ? pathname === '/' : pathname === prefix || pathname.startsWith(`${prefix}/`) || pathname.startsWith(prefix)
  )
}

export function hasMarketingCookieConsent(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const raw = localStorage.getItem('cookie_preferences')
    if (!raw) return false
    const prefs = JSON.parse(raw) as { marketing?: boolean }
    return prefs.marketing === true
  } catch {
    return false
  }
}

let gtagLoaded = false

/** Load Google Ads gtag only after explicit marketing cookie consent on a public page. */
export function loadMarketingGoogleAdsIfAllowed(pathname: string): void {
  if (typeof window === 'undefined') return
  if (!isMarketingRoute(pathname)) return
  if (!hasMarketingCookieConsent()) return
  if (gtagLoaded) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args)
  }
  window.gtag('js', new Date())
  window.gtag('config', GOOGLE_ADS_ID)

  gtagLoaded = true
}
